<script>
import * as R from 'ramda'
import { mapState, mapMutations, mapGetters } from 'vuex'
import { Maybe, ChartPattern, Wizard } from '@domain' // eslint-disable-line

let maps = {
  state: {
    region: ChartPattern.StateVsRegions,
  },
  region: {
    state: ChartPattern.StateVsRegions,
    region: ChartPattern.Regions,
    district: ChartPattern.RegionVsDistricts,
  },
  district: {
    region: ChartPattern.RegionVsDistricts,
    district: ChartPattern.Districts,
    campus: ChartPattern.DistrictVsCampuses,
  },
  campus: {
    district: ChartPattern.DistrictVsCampuses,
    campus: ChartPattern.Campuses,
  },
}

export default {
  page: {
    title: 'Chart Breakdown',
    meta: [{ name: 'description', content: 'choose chart type page...' }],
  },
  data() {
    return {
      options: [
        ['State of Texas', 'state'],
        ['ESC / Regions', 'region'],
        ['Districts', 'district'],
        ['Campuses', 'campus'],
      ],
      level1: Maybe.Nothing,
      level2: Maybe.Nothing,
    }
  },
  computed: {
    availableLevel2: function() {
      return this.level1.case({
        Nothing: () => {
          return {}
        },
        Just: lv1Key => maps[lv1Key] || {},
      })
    },
    patternChosen: function() {
      let keys = [this.level1, this.level2]
      return R.pipe(
        R.sequence(Maybe.of),
        R.map(R.path(R.__, maps))
      )(keys)
    },
    validChoose: function() {
      return Maybe.case(
        {
          Nothing: () => false,
          Just: _ => true,
        },
        this.patternChosen
      )
    },
    ...mapGetters('wizard', ['wizardNextRoute']),
  },
  ...mapState('wizard', {
    /**
     * @param {Wizard} state
     */
    mounted(state) {
      var that = this
      state.chartPattern.map(cPattern => {
        cPattern.case({
          StateVsRegions: () => {
            that.selectLevel1('state')
            that.selectLevel2('region')
          },
          Regions: () => {
            that.selectLevel1('region')
            that.selectLevel2('region')
          },
          RegionVsDistricts: () => {
            that.selectLevel1('region')
            that.selectLevel2('district')
          },
          Districts: () => {
            that.selectLevel1('district')
            that.selectLevel2('district')
          },
          DistrictVsCampuses: () => {
            that.selectLevel1('district')
            that.selectLevel2('campus')
          },
          Campuses: () => {
            that.selectLevel1('campus')
            that.selectLevel2('campus')
          },
        })
      })
    },
  }),
  methods: {
    selectLevel1: function(key) {
      let that = this
      this.level1.case({
        Nothing: () => (that.level1 = Maybe.of(key)),
        Just: prev => {
          if (prev !== key) {
            that.level1 = Maybe.of(key)
            // that.level2 = Maybe.Nothing
          }
        },
      })
      if (key) {
        that.level2 = key === 'state' ? Maybe.of('region') : Maybe.of(key)
      }
    },
    selectLevel2: function(key) {
      if (this.availableLevel2[key]) {
        this.level2 = Maybe.of(key)
      }
    },
    saveAndNext: function() {
      this.save(this.patternChosen)
      this.$router.push({ path: this.wizardNextRoute })
    },
    ...mapMutations('wizard', {
      save: 'SetChartPattern',
    }),
  },
}
</script>

<template>
  <v-layout
    :class="{'above-footer':Object.keys(availableLevel2).length <= 0}"
    class="iefix"
    column>
    <v-flex mt-5>
      <span class="section-title-font">Which breakdown do you want to see?</span>
    </v-flex>
    <v-flex>
      <v-layout
        justify-space-between
        row>
        <v-flex
          v-for="([text, k],index) in options"
          :key="index"
          d-inline-flex
          class="mt-5 mb-5 pr-3"
          fill-height
          xs3
          @click="selectLevel1(k)"
        >
          <v-card
            :class="{ 'active-card': k === level1[0] }"
            hover
            height="160">
            <v-card-text class="text-xs-center">{{ text }}</v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex v-show="Object.keys(availableLevel2).length > 0">
      <span class="section-title-font">I want to compare this to...</span>
    </v-flex>
    <v-flex v-show="Object.keys(availableLevel2).length > 0">
      <v-layout
        justify-space-between
        row>
        <v-flex
          v-for="([text, k],index) in options"
          :key="index"
          d-inline-flex
          class="mt-5 mb-5 pr-3"
          fill-height
          xs3
          @click="selectLevel2(k)"
        >
          <v-card
            :class="{ 'disabled-card': !availableLevel2[k], 'active-card': k === level2[0] }"
            :disabled="!availableLevel2[k]"
            hover
            height="160"
          >
            <v-card-text class="text-xs-center">{{ text }}</v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-divider/>
    <v-flex mt-3>
      <v-layout
        row
        justify-end>
        <v-flex xs2>
          <v-layout justify-end>
            <v-flex xs8>
              <v-btn
                :disabled="!validChoose"
                large
                block
                style="background-color: #243f92"
                @click="saveAndNext()"
              >Continue</v-btn>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<style lang='scss' scoped>
.section-title-font {
  display: inline-block;
  font-size: 30px;
  font-weight: bold;
  color: #707070;
}
.card {
  display: flex;
  align-items: center;
  > .card__text {
    text-align: center;
  }
}
.card__text {
  font-size: 16px;
  font-weight: bold;
  color: #707070;
}
.active-card {
  background: linear-gradient(to right, #11a0b0, #4bc2c7);


  > .card__text {
    color: white;
  }
}
.disabled-card {
  border: 1px solid #757575;
  background-color: #757575;
  box-shadow: none;
  cursor: unset;

  > .card__text {
    color: #ffffff;
  }
}
.above-footer {
  margin-bottom: 300px;
}
</style>
<style>
.iefix .btn--large .btn__content {
  padding: 0 !important;
}
</style>
